<h1 mat-dialog-title>Add link on description</h1>

<div mat-dialog-content>

  <div fxLayout="column" [formGroup]="linkForm" (ngSubmit)="onSubmit()" style="overflow: hidden;">
    <mat-form-field>
      <mat-label>Title</mat-label>
      <input matInput placeholder="Title" formControlName="title">
      @if (!linkForm.get('title').valid) {
      <mat-error>Please enter a valid title</mat-error>
      }
    </mat-form-field>

    <mat-label class="linkLabel">Link</mat-label>
    <quill-editor #editor trackChanges="all" formControlName="value" format="text" theme="bubble"
        [modules]="modules"></quill-editor>
  </div>
</div>

<div mat-dialog-actions class="action-buttons gap-8">
  <lib-button variant="stroked" mat-dialog-close>Cancel</lib-button>
  <lib-button variant="raised" color="primary" [disabled]="linkForm.invalid" (buttonClick)="onSubmit()">Save</lib-button>
</div>